<template>
  <div
    class="child-course-block"
    :style="blockStyle"
  >
    <TimelineItem
      v-for="(courseStartEndTime, index) in courseStartEndTimes"
      :key="index"
      :course-start-end-time="courseStartEndTime"
      :block-start="blockStart"
      :block-end="blockEnd"
      :block-height="blockHeight"
    />
  </div>
</template>

<script>
import HourMinutes from "./hourMinutes";
import TimelineItem from "./TimelineItem";

// 7시부터 11시까지
export default {
	name: "TimelineBlock",
	components: { TimelineItem },
	props: {
		startTime: {},
		endTime: {},
		blockHeight: {
			default: 300,
		},
		courseStartEndTimes: {},
	},
	data() {
		return {};
	},
	computed: {
		blockStyle() {
			return {
				height: `${this.blockHeight}px`,
			};
		},
		blockStart() {
			return new HourMinutes(this.startTime);
		},
		blockEnd() {
			return new HourMinutes(this.endTime);
		},
	},
	methods: {},
};
</script>

<style lang="scss">
.child-course-block {
	position: relative;
}

.course-time {
	position: absolute;
}
</style>
